import {
  ArrowButtons,
  Breakpoints,
  Gallery,
  GallerySlide,
  Layout,
} from '@volkswagen-onehub/components-core';
import React, {useEffect, useRef} from 'react';
import {LentilsWrapper} from './ui/lentils-wrapper';
import {useIdMirrorTheme} from '../../hooks/use-id-mirror-theme';
import {ArrowButtonsWrapper} from './ui/arrow-buttons-wrapper';
import {CustomLentils} from './ui/custom-lentils';
import {
  CardContainerMobile,
  GallerySlideWrapper,
} from './ui/id-mirror-carousel-styles';
import {getIdMirrorCards} from './utils/get-id-mirror-cards';
import styled from 'styled-components';

const IdMirrorCarouselContainer = styled.div`
  padding-bottom: var(--size-dynamic0200);
`;

export const IdMirrorCarousel = () => {
  const {registerRefs} = useIdMirrorTheme();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const darkRefs = [
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
  ];
  const lightRefs = [
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          registerRefs({
            cardsContentDark: darkRefs
              .map((r) => r.current)
              .filter(Boolean) as HTMLDivElement[],
            cardsContentLight: lightRefs
              .map((r) => r.current)
              .filter(Boolean) as HTMLDivElement[],
          });
        } else {
          registerRefs({
            cardsContentDark: null,
            cardsContentLight: null,
          });
        }
      },
      {threshold: 0.1},
    );

    if (wrapperRef.current) observer.observe(wrapperRef.current);
    return () => observer.disconnect();
  }, []);

  const cards = getIdMirrorCards(darkRefs, lightRefs, true);

  return (
    <IdMirrorCarouselContainer
      ref={wrapperRef}
      className="id-mirror-carousel-container"
    >
      <Layout
        data-testid="id-mirror-carousel-layout"
        appearance={{
          [Breakpoints.default]: [{name: 'agenda-carousel', columns: 24}],
          [Breakpoints.b960]: [
            {name: '.', columns: 3},
            {name: 'agenda-carousel', columns: 18},
            {name: '.', columns: 3},
          ],
        }}
      >
        <Gallery
          data-testid="id-mirror-carousel-slider"
          id="id-mirror-carousel"
          bottomElements={
            <>
              <ArrowButtonsWrapper>
                <ArrowButtons
                  buttonPreviousAriaLabel="To previous slide"
                  buttonNextAriaLabel="To next slide"
                />
              </ArrowButtonsWrapper>
              <LentilsWrapper>
                <CustomLentils />
              </LentilsWrapper>
            </>
          }
          aria-label="Id Mirror gallery"
          slidesPerPage={1}
          fadingEdges={{
            [Breakpoints.default]: 'normal',
            [Breakpoints.b960]: 'none',
          }}
        >
          {cards.map((card, i) => (
            <GallerySlide
              key={i}
              aria-labelledby={`slide-${i}-heading`}
              stretch
            >
              <GallerySlideWrapper className="gallery-slide-wrapper-mobile">
                <CardContainerMobile className="card-container-mobile">
                  {card}
                </CardContainerMobile>
              </GallerySlideWrapper>
            </GallerySlide>
          ))}
        </Gallery>
      </Layout>
    </IdMirrorCarouselContainer>
  );
};
